<template>
<main-content>
    <kt-panel>
        <kt-panel-body v-if="ip_location !== 'IR'">
            <div class="alert alert-danger" role="alert">
                {{ $t('label.ir_ip_error') }}
            </div>
        </kt-panel-body>
        <kt-panel-body v-else>
            <ivr-form :form_data="form_data" :submit="submit"></ivr-form>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import IVRForm from './components/form'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { ivrService, ipApi } from '@/common/api.service'
import {IvrSettlementVariant} from "@/constants/IvrSettlementVariant";
import { IvrShopType } from "@/constants/IvrShopType";

export default {
    components: {
        'main-content': mainContent,
        'ivr-form': IVRForm
    },
    data() {
        return {
            ip_location: '',
            IvrType: IvrShopType,
            phone_validate:false,
        }
    },
    mounted() {
        ipApi.ipLocation().then(response => {
            this.ip_location = response.data.countryCode;
        })
    },
    computed: {
        form_data: {
            get: function() {
                return this.$store.state.ivr.form_data
            },
            set: function(value) {
                this.$store.commit('ivr/setFormData', value)
            }
        }
    },
    methods: {
        submit(e) {
            // this.form_data.merchant_share_percent = $('#merchant_wage').val()
            // this.form_data.merchant_share_percent = 100;
            let form = $('#ivr_form');
            let btn = $('#submit_btn');
            if (this.form_data.ivr_shop_type===IvrShopType.IVR){
                this.phone_validate=true
            }
            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    category_code: {
                        required: true,
                    },
                    address: {
                        required: true,
                    },
                    ivr_shop_type: {
                        required: true,
                    },
                    phone_number: {

                        required: this.phone_validate,
                    },
                    logo: {
                        required: true
                    },
                    sheba_number: {
                        required: true
                    },
                    merchant_wage: {
                        required: true
                    },
                    wage: {
                        required: true
                    },
                    settlement_variant: {
                        required: true,
                    },
                    wallet_hashid: {
                        required: () => {
                            return this.form_data.settlement_variant === IvrSettlementVariant.CHARGE_WALLET;
                        },
                    },
                },
            });

            if(! form.valid()) {
                return
            }

            KTApp.progress(btn);

            let params = this.$store.getters['ivr/form_data'];

            ivrService.create(params).then(response => {
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.commit('ivr/clearFormData')
        })
    },
}
</script>

<style>

</style>